import { createErrorNotification } from "../toaster/creators";
import { addNotification } from "../toaster/actions";
import { Observable } from "rxjs";
const errorNotification = createErrorNotification("Failed to save the dashboard", { icon: "cross" });
export function createNotificationOnPostErrorEpic(ActionKeys) {
    return (actions$) => actions$
        .ofType(ActionKeys.ERROR)
        .mergeMap(() => Observable.of(addNotification(errorNotification)));
}
export function createNotificationOnFetchErrorEpic(ActionKeys) {
    return (actions$) => actions$
        .ofType(ActionKeys.FETCH_ITEM_ERROR)
        .mergeMap((action) => Observable.of(addNotification(createErrorNotification(action.payload, { icon: "cross" }))));
}
//# sourceMappingURL=notifications.js.map